import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'
import HeaderTabla from '../componentes/HeaderTabla'

const VerAtributos = ({ data, SeleccionarCategoria }) => {

	return (
		<div>
			<MDBTable hover responsive>
				<HeaderTabla array={['Activo', 'Categoría', 'Padre', 'Color', '']} />
				<MDBTableBody>

					{data.map((item, index) => {
						return (
							<tr key={index}>
								<td>{item.activo === 'true' ? 'Si' : 'No'}</td>
								<td>{item.nombre}</td>
								<td>{item.padre}</td>
								<td>{item.color === 'undefined' ? '' : item.color}</td>
								<td className="SinPadding">
									<div className="col text-center">
										<button
											onClick={SeleccionarCategoria(item, 'editar')}
											className="btn boton_estandar_blanco"
										><FontAwesomeIcon icon={faEdit} size="lg" />
										</button>

										<button
											onClick={SeleccionarCategoria(item, 'eliminar')}
											className="btn boton_estandar_blanco"
										><FontAwesomeIcon icon={faTrashAlt} size="lg" />
										</button>
									</div>

								</td>
							</tr>
						)

					})}

				</MDBTableBody>
			</MDBTable>
		</div>
	)
}

export default VerAtributos